<template>
    <div ref="boxplot" style="width:100%;height:500px;" ></div>   
</template>

<script>
import * as echarts from 'echarts';
import * as ecSimpleTransform from 'echarts-simple-transform'

export default({
    props:{
        jsonData:Array,
        title:Array,
        value_type:String,
        tooltip:Array,
        plotTitle:String
    },
    data(){
        return{
            plotData:[],
            barChart:null,
        }
    },
    watch:{
        jsonData(){    
            if(this.jsonData.length!=0){
                this.initChart()
            }else{
                this.barChart.clear()
            } 
            
        } 
    },
    methods: {
        initChart() {  
            this.plotData=[]
            this.plotData.push(this.title)
            for (var i in this.jsonData) {     
                var item = [];
                for (var j in this.jsonData[i]) {
                    item.push(this.jsonData[i][j]);
                }      
                this.plotData.push(item)
            }
            this.barChart = this.echarts.init(this.$refs.boxplot);
            echarts.registerTransform(ecSimpleTransform.aggregate);
            const option = {
                title: {
                    text: this.plotTitle
                },
                dataset: [
                    {
                        id: 'raw',
                        source:this.plotData
                    },
                    {
                        id: 'income_aggregate',
                        fromDatasetId: 'raw',
                        transform: [{
                            type: 'ecSimpleTransform:aggregate',
                            config: {
                                resultDimensions: [
                                    { name: 'min', from: 'value', method: 'min' },
                                    { name: 'Q1', from: 'value', method: 'Q1' },
                                    { name: 'median', from: 'value', method: 'median' },
                                    { name: 'Q3', from: 'value', method: 'Q3' },
                                    { name: 'max', from: 'value', method: 'max' },
                                    { name: 'type', from: 'type' }
                                ],
                                groupBy: 'type'
                            }
                        }]
                    }
                ],
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '10%',
                    right: '10%',
                    bottom: '15%'
                },
                xAxis: {
                    name: this.value_type,
                    nameLocation: 'middle',
                    nameGap: 30,
                    scale: true
                    },
                yAxis: {
                    type: 'category'
                },
                legend: {
                    top:'8%'
                },
                series: [
                    {   large:true,
                        name:'boxplot',
                        type: 'boxplot',
                        datasetId: 'income_aggregate',
                        itemStyle: {
                            color:'white',
                            borderColor: 'black'
                        },
                        encode: {
                            x: ['min', 'Q1', 'median', 'Q3', 'max'],
                            y: 'type',
                            itemName: ['type'],
                            tooltip: ['min', 'Q1', 'median', 'Q3', 'max']
                        }
                    },
                    {
                        name:'scatter',
                        type: 'scatter',
                        datasetId: 'raw',
                        symbolSize: 6,
                        tooltip: {
                            trigger: 'item'
                        },
                        itemStyle: {
                            color: 'rgb(234,101,100)'
                        },
                        encode: {
                            x: 'value',
                            y: 'type',
                            itemName: 'sample',
                            tooltip: this.tooltip
                        }
                    }
                ]
            };
            this.barChart.setOption(option);
            //随着屏幕大小调节图表
            window.onresize = this.barChart.resize();
       }
   }
})
</script>
